import { URL_DOMAIN, getJSON, requestOptionsGet } from "../globals";

const getPresalesOfOrganization = async (date, salePoint = null) => {
  const params = new URLSearchParams();
  if (date) params.append("date", date);
  if (salePoint) params.append("sale_point", salePoint);
  const query = params.toString() ? `?${params.toString()}` : "";
  return fetch(
    URL_DOMAIN + "presale/get-presales-of-organization" + query,
    requestOptionsGet
  ).then(getJSON);
};

export { getPresalesOfOrganization };
